import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { clientsApi } from '../services/api';
import { vorApi } from '../services/api';
import { toast } from 'react-toastify';

const VorNewAssessment = () => {
  const navigate = useNavigate();
  const [clients, setClients] = useState([]);
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({
    client_id: '',
    assessment_name: '',
    assessment_date: new Date().toISOString().split('T')[0],
  });

  useEffect(() => {
    clientsApi.getAll({ active: true, per_page: 0 })
      .then(res => setClients(res.data.clients || []))
      .catch(() => toast.error('Failed to load clients'));
  }, []);

  const handleChange = (e) => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.client_id || !form.assessment_name.trim()) {
      toast.error('Client and assessment name are required');
      return;
    }
    try {
      setSaving(true);
      const res = await vorApi.createAssessment(form);
      const id = res.data.assessment?.id;
      toast.success('Assessment created');
      navigate(`/vor/assessments/${id}/workflow`);
    } catch (err) {
      toast.error(err.response?.data?.error || 'Failed to create assessment');
    } finally {
      setSaving(false);
    }
  };

  const inputStyle = {
    width: '100%', padding: '10px 12px', border: '1px solid #D1D5DB',
    borderRadius: '6px', fontSize: '14px', boxSizing: 'border-box',
  };
  const labelStyle = { display: 'block', marginBottom: '6px', fontWeight: '500', fontSize: '14px', color: '#374151' };

  return (
    <div style={{ maxWidth: '600px', margin: '0 auto' }}>
      <div style={{ marginBottom: '24px' }}>
        <h1 style={{ margin: 0, fontSize: '26px', fontWeight: '700', color: '#1a1a2e' }}>
          New VoR Assessment
        </h1>
        <p style={{ margin: '4px 0 0', color: '#6B7280', fontSize: '14px' }}>
          Create a new Value of Risk assessment for a client
        </p>
      </div>

      <div style={{ backgroundColor: 'white', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)', padding: '30px' }}>
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '20px' }}>
            <label style={labelStyle}>Client *</label>
            <select name="client_id" value={form.client_id} onChange={handleChange} required style={inputStyle}>
              <option value="">Select a client…</option>
              {clients.map(c => (
                <option key={c.id} value={c.id}>{c.name}</option>
              ))}
            </select>
          </div>

          <div style={{ marginBottom: '20px' }}>
            <label style={labelStyle}>Assessment Name *</label>
            <input
              type="text" name="assessment_name" value={form.assessment_name}
              onChange={handleChange} required placeholder="e.g. 2025 Annual VoR Assessment"
              style={inputStyle}
            />
          </div>

          <div style={{ marginBottom: '30px' }}>
            <label style={labelStyle}>Assessment Date</label>
            <input type="date" name="assessment_date" value={form.assessment_date} onChange={handleChange} style={inputStyle} />
          </div>

          <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
            <button
              type="button" onClick={() => navigate('/vor/assessments')}
              style={{ padding: '10px 20px', border: '1px solid #D1D5DB', borderRadius: '6px', background: 'white', cursor: 'pointer', fontSize: '14px' }}
            >
              Cancel
            </button>
            <button
              type="submit" disabled={saving}
              style={{
                padding: '10px 24px', backgroundColor: saving ? '#9CA3AF' : '#6B3FA0',
                color: 'white', border: 'none', borderRadius: '6px',
                fontWeight: '600', cursor: saving ? 'not-allowed' : 'pointer', fontSize: '14px',
              }}
            >
              {saving ? 'Creating…' : 'Create & Start Workflow'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default VorNewAssessment;
